import React from "react";
import { interpolate, useCurrentFrame, useVideoConfig } from "remotion";

export const GeometricLiquidBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();

  // Morphing speed and movement
  const driftX = interpolate(frame, [0, 600], [0, 100]);
  const driftY = interpolate(frame, [0, 600], [0, 50]);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width,
        height,
        backgroundColor: "#0f172a", // Deep Indigo
        overflow: "hidden",
      }}
    >
      {/* Technical Grid Pattern */}
      <svg
        style={{
          position: "absolute",
          width: "200%",
          height: "200%",
          left: "-50%",
          top: "-50%",
          opacity: 0.15,
          transform: `translate(${-driftX % 40}px, ${-driftY % 40}px)`,
        }}
      >
        <defs>
          <pattern
            id="geometric-grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 40 0 L 0 0 0 40"
              fill="none"
              stroke="#22d3ee" // Neon Cyan
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#geometric-grid)" />
      </svg>

      {/* Morphing Liquid Blobs using SVG Filters */}
      <svg
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          filter: "url(#liquid-goo)",
        }}
      >
        <defs>
          <filter id="liquid-goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="40" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
              result="goo"
            />
          </filter>
        </defs>

        {/* Animated Blob 1 */}
        <circle
          cx={width * 0.3 + Math.sin(frame * 0.02) * 100}
          cy={height * 0.4 + Math.cos(frame * 0.03) * 150}
          r="180"
          fill="#bef264" // Electric Lime
          style={{ opacity: 0.8 }}
        />

        {/* Animated Blob 2 */}
        <circle
          cx={width * 0.7 + Math.cos(frame * 0.02) * 120}
          cy={height * 0.6 + Math.sin(frame * 0.025) * 100}
          r="220"
          fill="#a855f7" // Vivid Purple
          style={{ opacity: 0.6 }}
        />

        {/* Animated Blob 3 */}
        <circle
          cx={width * 0.5 + Math.sin(frame * 0.015) * 200}
          cy={height * 0.2 + Math.cos(frame * 0.02) * 80}
          r="150"
          fill="#22d3ee" // Neon Cyan
          style={{ opacity: 0.7 }}
        />
      </svg>

      {/* Subtle scanline overlay for more texture */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.1) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.02), rgba(0, 255, 0, 0.01), rgba(0, 0, 255, 0.02))",
          backgroundSize: "100% 4px, 3px 100%",
          pointerEvents: "none",
          opacity: 0.4,
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
